// extracted by mini-css-extract-plugin
export default {"stackContainer":"Stack_stackContainer__AmsBT","show":"Stack_show__pH2zB","stackBody":"Stack_stackBody__3PjDn","mask":"Stack_mask__Xb-KC"};